function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import parseUrl from 'url-parse';

function getBTCheckoutUrl() {
  var _window$bt$settings = window.bt.settings;
  _window$bt$settings = _window$bt$settings === void 0 ? {} : _window$bt$settings;
  var _window$bt$settings$b = _window$bt$settings.btCheckout;
  _window$bt$settings$b = _window$bt$settings$b === void 0 ? {} : _window$bt$settings$b;
  var _window$bt$settings$b2 = _window$bt$settings$b.url,
      btCheckoutUrl = _window$bt$settings$b2 === void 0 ? '' : _window$bt$settings$b2;
  return btCheckoutUrl;
}

function getCurrentPageSlug() {
  var _ref = window.bt || {},
      _ref$lil = _ref.lil;

  _ref$lil = _ref$lil === void 0 ? {} : _ref$lil;
  var _ref$lil$funnelSlug = _ref$lil.funnelSlug,
      funnelSlug = _ref$lil$funnelSlug === void 0 ? window.location.pathname.split('/').reverse()[0] : _ref$lil$funnelSlug;
  var suffix = ''; // allow adding a page-slug suffix in override settings for testing purposes

  if (window.localStorage) {
    try {
      var overrideSettings = window.localStorage.getItem('bt.lil');

      if (overrideSettings) {
        var overrideJson = JSON.parse(overrideSettings);

        if (typeof overrideJson.pageSlugSuffix !== 'undefined') {
          suffix = overrideJson.pageSlugSuffix;
        }
      }
    } catch (err) {
      console.debug('Error getting override settings', err);
    }
  }

  return "".concat(funnelSlug).concat(suffix);
}
/**
 *  Creates a cart with the specified items to the cart on BT Checkout (for the given funnel).  This will
 *  overwrite/replace previously created carts on BT Checkout.  The cart is stored in * server-side session on BT
 *  Checkout and will be available upon redirecting to the funnel's checkout page.
 *
 *  @param {Object.<string, number>} items - Pairs of SKU and Quantity indicating what to add to the cart
 *  @param {string | undefined} [funnelSlug] - The url slug for the desired funnel.  If omitted, it will be inferred from the current page.
 *  @returns {Promise<{ success: boolean, cart: Object | null, addedCartItems: Object.<string, number>, error?: string }>} - If success is `true`, the response
 *           includes the cart data.  If unsuccessful, an error is included in the response. */


export function createCart(_x, _x2) {
  return _createCart.apply(this, arguments);
}
/**
 * Redirects to the Checkout Page for the given funnel.
 * @param {string | undefined} [funnelSlug] - The url slug for the desired funnel.  If omitted, it is inferred from the current page url.
 */

function _createCart() {
  _createCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(items, funnelSlug) {
    var funnel, res, cart, responseContent;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            funnel = typeof funnelSlug === 'undefined' ? getCurrentPageSlug() : funnelSlug;
            _context.next = 3;
            return window.fetch("".concat(getBTCheckoutUrl(), "/api/cart"), {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                funnel: funnel,
                items: items
              })
            });

          case 3:
            res = _context.sent;

            if (!res.ok) {
              _context.next = 11;
              break;
            }

            _context.next = 7;
            return res.json();

          case 7:
            cart = _context.sent;
            return _context.abrupt("return", {
              success: true,
              cart: cart,
              addedCartItems: items
            });

          case 11:
            _context.next = 13;
            return res.text();

          case 13:
            responseContent = _context.sent;
            console.error('Unsuccessful response when adding to cart for BT Checkout', {
              funnel: funnel,
              items: items,
              status: res.status,
              body: responseContent
            });
            return _context.abrupt("return", {
              success: false,
              cart: null,
              error: responseContent
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createCart.apply(this, arguments);
}

export function redirectToCheckout(funnelSlug) {
  var slug = typeof funnelSlug === 'undefined' ? getCurrentPageSlug() : funnelSlug;
  var checkoutUrl = parseUrl("".concat(getBTCheckoutUrl(), "/checkout/").concat(slug));
  window.location.assign(checkoutUrl.toString());
}